// LabelRow.tsx
import React from 'react';
import { Toggle } from '@core/uilibrary';  // Assuming this is the correct import path

interface LabelRowProps {
  label:     string;
  required?: boolean;
  toggle?:   { checked: boolean; onChange: (v: boolean) => void };
}

const LabelRow: React.FC<LabelRowProps> = ({ label, required, toggle }) => (
  <div className="cse-field-label-row">
    <span className="cse-field-label">
      {label}{required && <span className="cse-required"> *</span>}
    </span>
    {toggle && (
      <Toggle
        checked={toggle.checked}
        onChange={toggle.onChange}
      />
    )}
  </div>
);

export default LabelRow;